import React from 'react';
import Slider from '@mui/material/Slider';
import {withStyles} from '@mui/styles';
import {theme} from '../../Theme';
import BidmiiTooltip from './BidmiiTooltip';

interface IProps {
  min: number;
  max: number;
  step: number;
  marks: {value: any; label?: any}[];
  track?: false | 'normal' | 'inverted' | undefined;
  defaultValue?: any;
  value?: any;
  onChange?: any;
  disabled?: boolean;
  style?: any;
}

const StyledSlider = withStyles({
  root: {
    color: theme.palette.blue.main,
    height: 4,
  },
  track: {
    height: 4,
    borderRadius: 50,
  },
  rail: {
    height: 3,
    borderRadius: 50,
  },
  mark: {
    color: theme.palette.secondary.main,
    width: 3,
  },
  markLabel: {
    fontFamily: 'AeonikProReqular, sans-serif',
    fontSize: 12,
    marginTop: -2,
    color: theme.palette.gray.dark,
  },
})(Slider);

function ValueLabelComponent(props: $TSFixMe) {
  const {children, value} = props;
  const title = value;
  return (
    <BidmiiTooltip title={title} placement="top">
      {children}
    </BidmiiTooltip>
  );
}

export default function BidmiiSlider(props: IProps) {
  return (
    <StyledSlider
      min={props.min}
      max={props.max}
      step={props.step}
      marks={props.marks}
      track={props.track || 'normal'}
      valueLabelDisplay="auto"
      defaultValue={props.defaultValue}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      components={{ValueLabel: ValueLabelComponent}}
      style={{...props.style, width: 'calc(100% - 24px)', marginLeft: 10}}
    />
  );
}
